/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ invoice: NonNullable<unknown>, order: NonNullable<unknown> }} Einvoice_Draft_Order_Total_DiffersInputs */

const vi_einvoice_draft_order_total_differs = /** @type {(inputs: Einvoice_Draft_Order_Total_DiffersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tổng thanh toán trên hóa đơn (${i?.invoice} ₫) khác tổng đơn hàng (${i?.order} ₫). Đơn hàng, kho và công nợ vẫn giữ nguyên; hãy kiểm tra lại trước khi phát hành.`)
};

/**

* @param {Einvoice_Draft_Order_Total_DiffersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_order_total_differs = /** @type {((inputs: Einvoice_Draft_Order_Total_DiffersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Order_Total_DiffersInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_order_total_differs(inputs)
});